import { render, staticRenderFns } from "./xlcs_old.vue?vue&type=template&id=1b356c43&scoped=true"
import script from "./xlcs_old.vue?vue&type=script&lang=js"
export * from "./xlcs_old.vue?vue&type=script&lang=js"
import style0 from "./xlcs_old.vue?vue&type=style&index=0&id=1b356c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b356c43",
  null
  
)

export default component.exports